import { createContext, useState } from "react";
import { clearSession, getStoredUser, saveSession } from "./session";


export const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [user, setUser] = useState(getStoredUser);

    const login = (token, userData) => {
        saveSession(token, userData);

        setToken(token);
        setUser(userData);
    };

    const logout = () => {
        clearSession();
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ token, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}
